// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2o2iI","bigColWidth":"Table_bigColWidth__39ZUc","biggerColWidth":"Table_biggerColWidth__1_rFg","row":"Table_row__W0SJE","col":"Table_col__2KuJr"};